// extracted by mini-css-extract-plugin
export default {"container":"StartMenu_container__+AyKz"};